export default "__VITE_ASSET__u$gdBwZZ__ 584w";